import { produce } from 'immer';
import { cloneDeep } from 'lodash';

import {
    CHANGE_PRICE_PACKAGES_COLUMNS_ORDER,
    CHANGE_PRICE_PACKAGES_COLUMNS_VISIBILITY,
    CHANGE_STATUS_PRICE_PACKAGE,
    PricePackagesAction,
    RESET_PRICE_PACKAGES_DATA,
    UPDATE_COLUMNS_SETTINGS_PRICE_PACKAGES_STATE,
    UPDATE_PRICE_PACKAGES_COLUMNS_WIDTH,
    UPDATE_PRICE_PACKAGES_DATA,
    UPDATE_PRICE_PACKAGES_SOURCE_PARAMS
} from '../actions/pricePackages';
import { getColumnsSettings } from '../declarations/common';
import { pricePackages } from '../typings/common';
import { PricePackagesState } from '../typings/pricePackages';
import { State } from '../typings/state';

export const pricePackagesInitialState: PricePackagesState = {
    gridData: {
        data: [],
        total: 100,
        allItemsIds: []
    },
    columnsSettings: getColumnsSettings(),
    sourceParams: { login: '' },
    selection: [],
    isSelectionEnabled: true
};

export function pricePackagesReducer(
    state: PricePackagesState = pricePackagesInitialState,
    action: PricePackagesAction,
    fullState: State
): PricePackagesState {
    switch (action.type) {
        case UPDATE_PRICE_PACKAGES_DATA:
            return produce(state, draft => {
                draft.gridData = cloneDeep(action.gridData);
            });
        case UPDATE_PRICE_PACKAGES_SOURCE_PARAMS:
            return produce(state, draft => {
                draft.sourceParams = cloneDeep(action.sourceParams);
                draft.gridData = pricePackagesInitialState.gridData;
            });
        case RESET_PRICE_PACKAGES_DATA:
            return produce(state, draft => {
                draft.gridData = pricePackagesInitialState.gridData;
            });
        case UPDATE_PRICE_PACKAGES_COLUMNS_WIDTH:
        case CHANGE_PRICE_PACKAGES_COLUMNS_VISIBILITY:
            return produce(state, draft => {
                draft.columnsSettings = cloneDeep(action.columns);
            });
        case CHANGE_PRICE_PACKAGES_COLUMNS_ORDER:
            return produce(state, draft => {
                draft.columnsSettings[pricePackages].columnOrder = cloneDeep(action.columnOrder);
            });
        case UPDATE_COLUMNS_SETTINGS_PRICE_PACKAGES_STATE:
            return produce(state, draft => {
                draft.columnsSettings = cloneDeep(action.columnsSettings);
            });
        case CHANGE_STATUS_PRICE_PACKAGE:
            return produce(state, draft => {
                draft.gridData.data[action.index].statusApprove = action.status;
            });
        default:
            return state;
    }
}
